export default class {
    constructor() {
        this.init();
    }

    init() {
        $('#ficheModal').on('show.bs.modal', function (ev) {
            const $modal = $(this);
            const $card = $(ev.relatedTarget).closest(".card");

            console.info($card);
            const data = {
                title: $card.find(".card-title a").text(),
                content: $card.data("content"),
                icon: $card.find(".card-img-top").attr('src')
            };

            $modal.find(".modal-logo").attr('src', data.icon);
            $modal.find(".modal-title").text(data.title);
            console.info(data.content);
            $modal.find(".modal-body .modal-text").html(data.content);
        })
    }
}
